/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../../routing/state-utils';

import {configureAdminResourceStates} from '../../common/controller/admin-resource-routing';
import {DataExportCopyModalComponent} from './data-export-copy-modal.component';
import {PERMISSIONS} from "../../../components/auth/auth-constants";
import {DataExportResource} from '../../../components/api/resources/resource/data-export.resource';

export function dataExportStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper('data-exports.data-export', DataExportResource, 'app.adm', 'app/admin');
    
        const readOnlyResolve = /*@ngInject*/ function() {
          const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

          return !LocalUserPermissions.hasNetworkPermission(PERMISSIONS.axAdvertiserAdmin.apiKey)
            && !LocalUserPermissions.hasNetworkPermission(PERMISSIONS.axPublisherAdmin.apiKey)
            && !LocalUserPermissions.hasAny(PERMISSIONS.axPublisherTeamAdmin.apiKey)
            && !LocalUserPermissions.hasAny(PERMISSIONS.axAdvertiserTeamAdmin.apiKey)
            && !LocalUserPermissions.hasNetworkPermission(PERMISSIONS.manageSystem.apiKey)
            && !LocalUserPermissions.hasNetworkPermission(PERMISSIONS.downloadLogs.apiKey);
        };
    
        const listConfigResolve = /*@ngInject*/ function() {
          const localUserProfile = adnRouterHelper.services.localUserProfile();
          const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

          if (localUserProfile.getCurrentApp() === 'DATA') {
            return {where: "source in STATS"};
          } else if (!LocalUserPermissions.hasNetworkPermission(PERMISSIONS.manageSystem.apiKey)
            && !LocalUserPermissions.hasNetworkPermission(PERMISSIONS.downloadLogs.apiKey)) {
            return {where: "source in STATS"};
          } else {
            return {where: "source in RAW_LOG,STATS"};
          }
        };
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'DataExport',
          listTag: 'adn-data-export-list-page',
          editTag: 'adn-data-export-edit-page',
          listData: {
            app: ['DATA', 'ADVERTISING']
          },
          listResolve: {
            readOnly: readOnlyResolve,
            listConfig: listConfigResolve
          },
          itemResolve: {
            readOnly: readOnlyResolve,
            copyConfig: function() {
              return {
                modalComponent: DataExportCopyModalComponent,
                stateUrl: 'app.adm.data-exports.data-export',
                lcase: 'data export',
                ucase: 'Data Export'
              };
            }
          }
        });
  }, adnRouterHelper);
}
